import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { showPaymentsApi } from '../../redux/payments/paymentApiCalls'
import { DefaultPaymentInterface, PaymentInterface, ShowPaymentContext } from './types'
import DataPayments from './DataPayments'
import AddPaymentModal from './AddPaymentModal'
import DeletePaymentModal from './DeletePaymentModal'
import { FaChevronCircleLeft } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import { getMedecinTypesApi } from '../../redux/medecinType/medecinTypeApiCalls'

const ShowPayments = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false)
  const [showAddPaymentModal, setShowAddPaymentModal] = useState(false)
  const [showDeletePaymentModal, setShowDeletePaymentModal] = useState(false)
  const [selectedPayment, setSelectedPayment] = useState<PaymentInterface>(DefaultPaymentInterface)
  const [subscriptionYear, setSubscriptionYear] = useState<string>("")
  const [note, setNote] = useState<string>("")
  const [statusType, setStatusType] = useState<string>("")

  const dispatch: any = useDispatch()

  useEffect(() => {
    const fetchAPIs  = async () => {
      await dispatch(getMedecinTypesApi())
    }
    fetchAPIs()
  }, [dispatch])


  useEffect(() => {
    const fetchAPIs  = async () => {
      await dispatch(showPaymentsApi())
    }
    fetchAPIs()
  }, [dispatch])

  const navigate = useNavigate()

  return (
    <ShowPaymentContext.Provider value={{
      showSuccessMsg, setShowSuccessMsg,
      showAddPaymentModal, setShowAddPaymentModal,
      showDeletePaymentModal, setShowDeletePaymentModal,
      selectedPayment, setSelectedPayment,
      subscriptionYear, setSubscriptionYear,
      note, setNote,
      statusType, setStatusType,
    }}>
      <div className="flex justify-start gap-2">
        <FaChevronCircleLeft style={{ fontSize: "30px" }} className="text-main" onClick={() => navigate("/")}/>
      </div>

      <DataPayments />
      <AddPaymentModal modal={showAddPaymentModal} toggle={() => setShowAddPaymentModal(!showAddPaymentModal)} /> 
      {showDeletePaymentModal && selectedPayment._id &&
        <DeletePaymentModal modal={showDeletePaymentModal} toggle={() => setShowDeletePaymentModal(!showDeletePaymentModal)} />
      }
    </ShowPaymentContext.Provider>
  )
}

export default ShowPayments;
